

// AUMENTA OU DIMINUI A QUANTIDADE DE UM PRODUTO DO CARRINHO, SEM MUTAR OS DADOS ORIGINAIS
export const changeAmount = ({ type, index, cart, products }) => {
    const nextProducts = [...products];
    const product = { ...nextProducts[index] };
    const unitPrice = product.total_price / product.amount;

    if (type === 'add') {
        product.amount += 1;
        product.total_price += unitPrice;

    } else if (type === 'minus' && product.amount > 1) {
        product.amount -= 1;
        product.total_price -= unitPrice;
    }

    nextProducts[index] = product;

    const nextCart = {
        ...cart,
        products: nextProducts,
        cart_price: nextProducts.reduce((total, item) => total + item.total_price, 0),
    };

    return { products: nextProducts, cart: nextCart };
};
